import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const ActionButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  textTransform: "uppercase",
  height: "40px",
}));
